
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Users, BookOpen, Menu, Star, MessageSquare } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Drawer, DrawerContent, DrawerTrigger } from '@/components/ui/drawer';
import { MobileMenu } from './MobileMenu';

export function BottomNavigation() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  
  const isActive = (path: string) => {
    if (path === '/dashboard') {
      return location.pathname === '/' || location.pathname === '/dashboard';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="fixed bottom-0 left-0 z-40 flex w-full justify-around border-t bg-background p-2 md:hidden">
      <Link to="/users" className="flex flex-1 flex-col items-center">
        <Button 
          variant="ghost" 
          size="icon" 
          className={cn(
            "h-10 w-10 rounded-full",
            isActive('/users') && "bg-primary text-primary-foreground"
          )}
        >
          <Users className="h-5 w-5" />
          <span className="sr-only">Users</span>
        </Button>
        <span className="text-xs">Users</span>
      </Link>
      
      <Link to="/courses" className="flex flex-1 flex-col items-center">
        <Button 
          variant="ghost" 
          size="icon" 
          className={cn(
            "h-10 w-10 rounded-full",
            isActive('/courses') && "bg-primary text-primary-foreground"
          )}
        >
          <BookOpen className="h-5 w-5" />
          <span className="sr-only">Courses</span>
        </Button>
        <span className="text-xs">Courses</span>
      </Link>
      
      <Drawer open={isMenuOpen} onOpenChange={setIsMenuOpen}>
        <DrawerTrigger asChild>
          <div className="flex flex-1 flex-col items-center">
            <Button 
              variant="outline" 
              size="icon" 
              className="h-10 w-10 rounded-full"
            >
              <Menu className="h-5 w-5" />
              <span className="sr-only">Menu</span>
            </Button>
            <span className="text-xs">Menu</span>
          </div>
        </DrawerTrigger>
        <DrawerContent className="h-[90%]">
          <MobileMenu onClose={() => setIsMenuOpen(false)} />
        </DrawerContent>
      </Drawer>
      
      <Link to="/reviews" className="flex flex-1 flex-col items-center">
        <Button 
          variant="ghost" 
          size="icon" 
          className={cn(
            "h-10 w-10 rounded-full",
            isActive('/reviews') && "bg-primary text-primary-foreground"
          )}
        >
          <Star className="h-5 w-5" />
          <span className="sr-only">Reviews</span>
        </Button>
        <span className="text-xs">Reviews</span>
      </Link>
      
      <Link to="/chatlogs" className="flex flex-1 flex-col items-center">
        <Button 
          variant="ghost" 
          size="icon" 
          className={cn(
            "h-10 w-10 rounded-full",
            isActive('/chatlogs') && "bg-primary text-primary-foreground"
          )}
        >
          <MessageSquare className="h-5 w-5" />
          <span className="sr-only">Chat Logs</span>
        </Button>
        <span className="text-xs">Chats</span>
      </Link>
    </div>
  );
}
